export default [
  { key: 'global_showall_label', value: 'all' },
  { key: 'global_positiontype_apprenticeship', value: '7959' },
  { key: 'global_positiontype_internship', value: '7103' },
  { key: 'global_positiontype_permanentjob', value: '1107' },
  { key: 'global_positiontype_temporaryjob', value: '8042' },
  { key: 'global_positiontype_vie', value: '7104' }
]
